// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getWarehouseRequest: ['data'],
  getWarehouseSuccess: ['data'],
  getWarehouseFailure: ['err'],

  createWarehouseRequest: ['data'],
  createWarehouseSuccess: ['data'],
  createWarehouseFailure: ['err'],

  updateWarehouseRequest: ['data'],
  updateWarehouseSuccess: ['data'],
  updateWarehouseFailure: ['err'],

  deleteWarehouseRequest: ['data'],
  deleteWarehouseSuccess: ['data'],
  deleteWarehouseFailure: ['err']

})

export const WarehouseTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_WAREHOUSE_SUCCESS]: success,
  [Types.GET_WAREHOUSE_REQUEST]: request,
  [Types.GET_WAREHOUSE_FAILURE]: failure,

  [Types.CREATE_WAREHOUSE_SUCCESS]: success,
  [Types.CREATE_WAREHOUSE_REQUEST]: request,
  [Types.CREATE_WAREHOUSE_FAILURE]: failure,

  [Types.UPDATE_WAREHOUSE_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_WAREHOUSE_REQUEST]: manipulateRequest,
  [Types.UPDATE_WAREHOUSE_FAILURE]: manipulateFailure,

  [Types.DELETE_WAREHOUSE_SUCCESS]: manipulateSuccess,
  [Types.DELETE_WAREHOUSE_REQUEST]: manipulateRequest,
  [Types.DELETE_WAREHOUSE_FAILURE]: manipulateFailure

})



// WEBPACK FOOTER //
// ./src/Redux/WarehouseRedux.js